module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_plan_included_04_black-d12ec21b5c57358fc8f2deec158813fc.png";